// extracted by mini-css-extract-plugin
module.exports = {"balanceAdjustmentDetailsBody":"BalanceAdjustmentsDetails_balanceAdjustmentDetailsBody__NW7MS"};